import type { HttpClient } from './HttpClient';
import type { ApiClient } from './ApiClients';

export class ApiClientFormData implements ApiClient<FormData> {
  constructor(private httpClient: HttpClient) {}

  async post<T>(path: string, body: FormData): Promise<T> {
    return this.httpClient.fetch(path, {
      method: 'POST',
      body,
    }) as Promise<T>;
  }

  async delete(path: string): Promise<void> {
    return this.httpClient.fetch(path, {
      method: 'DELETE',
    });
  }

  async patch<T>(path: string, body: FormData): Promise<T> {
    return this.httpClient.fetch(path, {
      method: 'PATCH',
      body,
    }) as Promise<T>;
  }
}
